/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
    selectPreferences,
    selectIsNative,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import { getPLCCDetailsHtml } from 'yoda-site-components/lib/actions/PLCCAction';
import {
    triggerModuleImpressionTracking,
    triggerPlccAnalytics,
} from 'yoda-site-components/lib/actions/AnalyticsAction';
import get from 'lodash/get';
import PLCCSlidePanelLazy from 'yoda-site-components/lib/components/PLCCSlidePanel/PLCCSlidePanelLazy';
import CreditCard from '../../assets/svg/Credit_Card.svg';

const defaultState = {
    isSuccess: false,
    isLoading: true,
};
let plccMountAnalyticsTriggered = false;
function PLCCBanner({ automationId, PLCCMessage, preferences }) {
    const [state, setState] = useState(defaultState);
    const [showOfferDetailsSlider, setOfferDetailsSlider] = useState(false);
    const isNative = useSelector(selectIsNative);
    // eslint-disable-next-line no-shadow
    const plccDynamicBanner = useSelector((state) => state.plccDynamicBanner);
    const dispatch = useDispatch();
    const { PLCCBannerBannerConfig: { emptyDivHeight = 50 } = {} } = preferences;
    const specialFinancingContent = preferences?.plccBannerConfig?.specialfinancingcontent || '';

    const checkSpecialFinancingBanner = (PLCCMessage) => {
        return PLCCMessage === specialFinancingContent;
    };
    const isSpecialFinancingBanner = checkSpecialFinancingBanner(PLCCMessage);
    // eslint-disable-next-line no-restricted-globals
    useEffect(() => {
        if (!plccDynamicBanner?.detailsHtml)
            dispatch(getPLCCDetailsHtml(plccDynamicBanner?.detailsLink?.url));
        if (!plccMountAnalyticsTriggered) {
            dispatch(
                triggerModuleImpressionTracking({
                    name: 'pdp plcc apply & buy : special financing',
                    linktext: 'plcc apply & buy special financing ; banner displayed',
                })
            );
            plccMountAnalyticsTriggered = true;
        }
        const fetchPLCCBannerData = async () => {
            try {
                /* istanbul ignore next */
                if (PLCCMessage) {
                    setState({
                        ...state,
                        isSuccess: true,
                        isLoading: false,
                    });
                } else {
                    setState((prevState) => ({
                        ...prevState,
                        isSuccess: false,
                        isLoading: false,
                    }));
                }
            } catch (error) {
                /* istanbul ignore next */
                console.error('Error fetching PLCCbanner data:', error);
                setState((prevState) => ({
                    ...prevState,
                    isSuccess: false,
                    isLoading: false,
                }));
            }
        };

        fetchPLCCBannerData();
    }, [PLCCMessage]);

    const handleTriggerAnalytics = (payload) => {
        dispatch(triggerPlccAnalytics(payload));
    };
    /* istanbul ignore next */
    const toShowLearnMore = () => {
        const getOfferDetailsContentURL =
            '/content-aggregator/shared-components/zones/S1/s/cf-plcc-slide-panel?searchTerm=cf-plcc-slide-panel';

        if (!plccDynamicBanner?.detailsHtml || plccDynamicBanner?.detailsHtml.length === 0) {
            dispatch(getPLCCDetailsHtml(getOfferDetailsContentURL));
        }
        if (!showOfferDetailsSlider) {
            handleTriggerAnalytics({
                name: 'pdp plcc apply & buy : special financing',
                linktext: 'learn more',
            });
        }
        setOfferDetailsSlider(!showOfferDetailsSlider);
    };
    return (
        <>
            {/* Placeholder to avoid CLS */}
            {state.isLoading && emptyDivHeight && (
                <div
                    style={{
                        minHeight: `${emptyDivHeight}px`,
                    }}
                />
            )}
            {state.isSuccess ? (
                <ErrorBoundary>
                    <div
                        className={`${dt([
                            'bg-gray-200',
                            'p-3',
                            'flex',
                            'rounded',
                            'bg-light-white',
                            'mt-4',
                        ])}`}
                        data-automation-id={automationId}
                    >
                        <div className={dt(['m-0', 'mr-2'])}>
                            <Icon height="30px" width="30px" iconType="svg">
                                <CreditCard />
                            </Icon>
                        </div>
                        <div className={dt(['text-sm'])}>
                            {PLCCMessage && (
                                <>
                                    <span // eslint-disable-next-line react/no-danger
                                        dangerouslySetInnerHTML={{ __html: `${PLCCMessage}` }}
                                    />
                                    <a
                                        target="_blank"
                                        className={dt([
                                            'underline',
                                            'cursor-pointer',
                                            'inline-block',
                                        ])}
                                        rel="noreferrer"
                                        onClick={toShowLearnMore}
                                    >
                                        Learn More
                                    </a>
                                </>
                            )}
                        </div>
                        {showOfferDetailsSlider && (
                            <PLCCSlidePanelLazy
                                siteCode={get(preferences, 'plccBanner.plccBannerSiteCode', '')}
                                enablePLCCSliderNewContent
                                plccDynamicBanner={plccDynamicBanner}
                                triggerPlccAnalytics={handleTriggerAnalytics}
                                togglePLCCDetailSlider={toShowLearnMore}
                                isNative={isNative}
                                from={
                                    isSpecialFinancingBanner
                                        ? 'specialFinancing'
                                        : 'JCPenney Credit Card'
                                }
                            />
                        )}
                    </div>
                </ErrorBoundary>
            ) : null}
        </>
    );
}

PLCCBanner.propTypes = {
    automationId: PropTypes.string,
    PLCCMessage: PropTypes.string,
    preferences: PropTypes.object,
};

PLCCBanner.defaultProps = {
    automationId: 'plcc-banner-content',
    PLCCMessage: '',
    preferences: {},
};

const mapStateToProps = (state) => ({
    preferences: selectPreferences(state),
});

export default memo(connect(mapStateToProps)(PLCCBanner));
